/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:a6601102-9932-4d1e-b45d-6282560cf72a",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_KMbO6t571",
    "aws_user_pools_web_client_id": "1qnsf63gdq4koi0nsqmn1ai13s",
    "oauth": {
        "domain": "searchapplicationfbb2afeb-fbb2afeb-dev.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://dev.d1rcjjv6tdpjni.amplifyapp.com/",
        "redirectSignOut": "http://localhost:3000/,https://dev.d1rcjjv6tdpjni.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
